export default {
  path: '/clientes/:id',
  component: () => import('@/components/pages/Clients/Client.vue')
}
